<script lang="ts">
  import { scale } from 'svelte/transition';
</script>

<div class="request-container" transition:scale|local>
  <div id="mic-request-title" class="mx-auto mb-8 text-4xl">Enable Microphone</div>

  <p class="text-white text-2xl">
    Get ready to sing, the ride will begin shortly! We're warming up the pitch detection machine...
  </p>
</div>

<style lang="postcss">
  .request-container {
    position: relative;
    margin: auto;
    top: 10%;
    height: 80%;
    width: 80%;
    text-align: center;
    z-index: 40;
  }

  #mic-request-title {
    font-family: 'Luckiest Guy', Impact, 'Arial Narrow Bold', sans-serif;
    color: #ffc400;
    text-shadow: 4px 4px 10px black;
  }
</style>
